import Vue from 'vue'
import Vuex from 'vuex'
import channels202006 from './202006/channels'
import channels202007 from './202007/channels'
import channels202008 from './202008/channels'
import db from '@/plugins/firebase'
import { uuid } from 'vue-uuid'
// const dbCompany = db.collection('company')
// const dbProvider = db.collection('provider')
const _ = require('lodash')
const axios = require('axios')
const beforeRange = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
const afterRange = [11, 12, 13, 14, 15, 16, 17, 18, 19, 20]

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    dateTab: '',
    selectTime: 'すべて',
    companyLive: [],
    providerLive: [],
    companyLiveDate: [],
    providerLiveDate: [],
    livePage: {},
    liveType: '',
    lastCompanySnapshots: null,
    lastProviderSnapshots: null,
    accessToken: '',
    userData: {},
    targetAgeObject: { 1: 'プレママ', 2: '0歳', 3: '1歳', 4: '２歳', 5: '３歳', 6: '４歳', 7: '５歳', 8: '小学生', 9: 'パパ・ママ' },
    providerDataCompleted: false,
    companyDataCompleted: false,
    lastSelectedContent: 'all',
    lastSelectedDateTab: '2020-10-02',
    scrollYatTop: 0
  },
  mutations: {
    setDateTab (state, data) {
      state.dateTab = data
    },
    setTimeLine (state, data) {
      state.selectTime = data
    },
    setCompanyLive (state, doc) {
      const data = doc.data()
      data.id = doc.id
      state.companyLive.push(data)
    },
    setProviderLive (state, doc) {
      const data = doc.data()
      data.id = doc.id
      state.providerLive.push(data)
    },
    resetCompanyLive (state) {
      state.companyLive = []
    },
    resetProviderLive (state) {
      state.providerLive = []
    },
    setCompanyLiveDate (state, data) {
      state.companyLiveDate = data
    },
    setProviderLiveDate (state, data) {
      state.providerLiveDate = data
    },
    setLive (state, data) {
      state.livePage = data
    },
    setLiveType (state, data) {
      state.liveType = data
    },
    setLastCompanySnapshots (state, data) {
      state.lastCompanySnapshots = data
    },
    setLastProviderSnapshots (state, data) {
      state.lastProviderSnapshots = data
    },
    setAccessToken (state) {
      const cookies = document.cookie
      const cookiesArray = cookies.split(';')
      for (var c of cookiesArray) {
        const cArray = c.split('=')
        if (cArray[0].indexOf('_token') !== -1) {
          state.accessToken = cArray[1]
        }
      }
    },
    setUserData (state, userData) {
      state.userData = userData
    },
    setCurrentTab (state, data) {
      state.currentTab = data
    }
  },
  actions: {
    async setLiveProgram ({ commit, dispatch }) {
      await dispatch('resetLiveProgram')
      await Promise.all([dispatch('getCompanyLivePrograms'), dispatch('getProviderLivePrograms')])
      return true
    },
    async resetLiveProgram ({ commit }) {
      commit('resetCompanyLive')
      commit('resetProviderLive')
      return true
    },
    async getCompanyLivePrograms ({ state, commit }, { isAll = false, month }) {
      let dbCompany
      if (month === '202006') {
        dbCompany = db.collection('company')
      } else if (month === '202007') {
        dbCompany = db.collection('company07')
      } else {
        dbCompany = db.collection('company08')
      }
      let ref = dbCompany.where('isApproved', '==', true)
      if (!isAll) {
        ref = ref.limit(10)
      }
      if (state.lastCompanySnapshots) {
        ref = ref.startAfter(state.lastCompanySnapshots)
      }
      const querySnapshot = await ref.get()
      querySnapshot.docs.forEach((doc) => {
        commit('setCompanyLive', doc)
      })
      commit('setLastCompanySnapshots', querySnapshot.docs[querySnapshot.docs.length - 1])
      return new Promise((resolve, reject) => {
        if (querySnapshot.docs.length) {
          resolve()
        } else {
          reject(new Error('complete'))
        }
      })
    },
    async getProviderLivePrograms ({ state, commit }, { isAll = false, month }) {
      let dbProvider
      if (month === '202006') {
        dbProvider = db.collection('provider')
      } else if (month === '202007') {
        dbProvider = db.collection('provider07')
      } else if (month === '202009') {
        dbProvider = db.collection('provider0915')
      } else {
        dbProvider = db.collection('provider08')
      }
      let ref = dbProvider.where('isApproved', '==', true)
      if (!isAll) {
        ref = ref.limit(10)
      }
      if (state.lastProviderSnapshots) {
        ref = ref.startAfter(state.lastProviderSnapshots)
      }
      const querySnapshot = await ref.get()
      if (isAll) {
        const cloneProviders = querySnapshot.docs.slice()
        cloneProviders.some((v, i) => {
          if (v.data().eventname === 'リトル・ママオンラインマルシェ') {
            cloneProviders.splice(i, 1)
          }
        })
        const orderProviders = []
        for (let i = 0; i < cloneProviders.length; i++) {
          orderProviders.push(cloneProviders[i].data())
          orderProviders[i].priority = Number(cloneProviders[i].data().deliveryFrame[0])
          orderProviders[i].id = cloneProviders[i].id
        }
        orderProviders.sort(function (a, b) {
          if (a.priority < b.priority) {
            return -1
          } else {
            return 1
          }
        })
        orderProviders.forEach((data) => {
          commit('setProviderLive', data)
        })
      } else {
        querySnapshot.docs.forEach((doc) => {
          commit('setProviderLive', doc)
        })
      }
      // commit('setLastProviderSnapshots', querySnapshot.docs[querySnapshot.docs.length - 1])
      // return new Promise((resolve, reject) => {
      //   if (querySnapshot.docs.length) {
      //     resolve()
      //   } else {
      //     reject(new Error('complete'))
      //   }
      // })
    },
    async getHyblidProviderLivePrograms ({ state, commit }) {
      const dbProvider = db.collection('provider0915').where('isApproved', '==', true)
      // 一旦全部取得
      const querySnapshot = await dbProvider.get()
      querySnapshot.docs.forEach((doc) => {
        commit('setProviderLive', doc)
      })
      state.providerDataCompleted = true
    },
    async getTsuruhaCompanyLivePrograms ({ state, commit }) {
      const dbProvider = db.collection('company1002').where('isApproved', '==', true)
      // 一旦全部取得
      const querySnapshot = await dbProvider.get()
      querySnapshot.docs.forEach((doc) => {
        commit('setCompanyLive', doc)
      })
      state.companyDataCompleted = true
    },
    async getTsuruhaProviderLivePrograms ({ state, commit }) {
      const dbProvider = db.collection('provider1002').where('isApproved', '==', true)
      // 一旦全部取得
      const querySnapshot = await dbProvider.get()
      querySnapshot.docs.forEach((doc) => {
        commit('setProviderLive', doc)
      })
      state.providerDataCompleted = true
    },
    async getHyblidCompanyLivePrograms ({ state, commit }) {
      const dbProvider = db.collection('company0915').where('isApproved', '==', true)
      // 一旦全部取得
      const querySnapshot = await dbProvider.get()
      querySnapshot.docs.forEach((doc) => {
        commit('setCompanyLive', doc)
      })
      state.companyDataCompleted = true
    },
    getCompanyLivePage ({ commit, dispatch }, { docId, month }) {
      let dbCompany
      if (month === '202006') {
        dbCompany = db.collection('company')
      } else if (month === '202007') {
        dbCompany = db.collection('company07')
      } else if (month === '202008') {
        dbCompany = db.collection('company08')
      } else {
        dbCompany = db.collection('company1002')
      }
      dbCompany
        .doc(docId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            commit('setLive', doc.data())
            commit('setLiveType', 'company')
          } else {
            dispatch('getProviderLivePage', { docId, month })
          }
        })
        .catch((error) => {
          console.error('Error getting document: ', error)
        })
    },
    getProviderLivePage ({ commit, dispatch }, { docId, month }) {
      let dbProvider
      if (month === '202006') {
        dbProvider = db.collection('provider')
      } else if (month === '202007') {
        dbProvider = db.collection('provider07')
      } else if (month === '202008') {
        dbProvider = db.collection('provider08')
      } else {
        dbProvider = db.collection('provider1002')
      }
      dbProvider
        .doc(docId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            commit('setLive', doc.data())
            commit('setLiveType', 'provider')
          } else {
            dispatch('getCompanyLivePage', docId)
          }
        })
        .catch((error) => {
          console.error('Error getting document: ', error)
        })
    },
    async fetchUserData ({ commit, state }) {
      const accessToken = state.accessToken
      if (!accessToken) {
        return
      }
      const NewApiUrl = require(`../../env.${process.env.NODE_ENV}.js`).NEW_API_URL
      try {
        const res = await axios.get(NewApiUrl + '/v1/me', {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
        const userData = res.data.data
        if (!res.data.data) {
          state.accessToken = ''
          return
        }
        commit('setUserData', userData)
      } catch (e) {
        console.log(e)
        document.cookie = '_token=; domain=.l-ma.co.jp; path=/'
      }
    },
    async getDocIdByUUid ({ commit }, payload) {
      const ref = db.collection('uuids').where('id', '==', payload.uuId)
      const data = await ref.where('id', '==', payload.uuId).get()
      const docId = data.docs[0].data().docId
      return docId
    }
  },
  getters: {
    companyLive0624: state => {
      const range = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
      const ary = state.companyLive.filter((live) => {
        return _.intersection(Object.values(live.deliveryFrame), range).length
      })
      return ary
    },
    providerLive0624: state => {
      const range = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
      const ary = state.providerLive.filter((live) => {
        return _.intersection(Object.values(live.deliveryFrame), range).length
      })
      return ary
    },
    companyLive0625: state => {
      const range = ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20']
      const ary = state.companyLive.filter((live) => {
        return _.intersection(Object.values(live.deliveryFrame), range).length
      })
      return ary
    },
    providerLive0625: state => {
      const range = ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20']
      const ary = state.providerLive.filter((live) => {
        return _.intersection(Object.values(live.deliveryFrame), range).length
      })
      return ary
    },
    companyLive0728: state => {
      const range = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
      const ary = state.companyLive.filter((live) => {
        return _.intersection(Object.values(live.deliveryFrame), range).length
      })
      return ary
    },
    providerLive0728: state => {
      const range = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
      console.log('309', state.providerLive)
      const ary = state.providerLive.filter((live) => {
        console.log('into310')
        return _.intersection(Object.values(live.deliveryFrame), range).length
      })
      return ary
    },
    companyLive0729: state => {
      const range = ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20']
      const ary = state.companyLive.filter((live) => {
        return _.intersection(Object.values(live.deliveryFrame), range).length
      })
      return ary
    },
    providerLive0729: state => {
      const range = ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20']
      const ary = state.providerLive.filter((live) => {
        return _.intersection(Object.values(live.deliveryFrame), range).length
      })
      return ary
    },
    companyLive0827: state => {
      const range = beforeRange
      const ary = state.companyLive.filter((live) => {
        return _.intersection(Object.values(live.deliveryFrame), range).length
      })
      return ary
    },
    providerLive0827: state => {
      const range = beforeRange
      const ary = state.providerLive.filter((live) => {
        return _.intersection(Object.values(live.deliveryFrame), range).length
      })
      return ary
    },
    companyLive0828: state => {
      const range = afterRange
      const ary = state.companyLive.filter((live) => {
        return _.intersection(Object.values(live.deliveryFrame), range).length
      })
      return ary
    },
    providerLive0828: state => {
      const range = afterRange
      const ary = state.providerLive.filter((live) => {
        return _.intersection(Object.values(live.deliveryFrame), range).length
      })
      return ary
    },
    providerLive0915: state => {
      return state.providerLive
    },
    companyLive0915: state => {
      return state.companyLive
    },
    accessToken: state => {
      return state.accessToken
    },
    getUserData: state => {
      return state.userData
    },
    getTargetAgeObject: state => {
      return state.targetAgeObject
    },
    getUUid () {
      return uuid.v4()
    }
  },
  modules: {
    channels202006: channels202006,
    channels202007: channels202007,
    channels202008: channels202008
  }
})
